<section>
    <div class="title">
        <h2>{{ showPlanNameHeader() | lowercase }}</h2>
    </div>
    <div class="content">
        <div class="promotion-container" *ngIf="showDeviceCreditPromo && promotionData.length>0">
            <div class="multiple-promotions">
                <xm-media-image [imageOptions]="promoIcon" class="promotion-dollar-icon"></xm-media-image>
                <div>
                    <p>{{promotionHeader}}</p>
                    <ul class="promotions-list">
                        <li class="promotions-desc" *ngFor="let data of promotionData">{{ data }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="header">{{ pageData.header }}</div>
        <div class="description">{{ pageData.description }}</div>
        <div class="plan-tiers">
            <xm-unlimited-tier-selector *ngFor="let tier of tierData" [unlimitedTierPlan]="tier"
                [tierPrice]="getPrice(filterUnlimitedTier(tier.radioOption.value, planEligibility.plans))"
                (emitPlanCode)="onEmitPlanCode($event)"
                [priceSymbol]="showPriceSymbol()"
                [showInUseBadge]="showInUseBadge(tier)"
                [showScheduledBadge]="shouldShowScheduledBadge(filterUnlimitedTier(tier.radioOption.value, planEligibility.plans))">
            </xm-unlimited-tier-selector>
        </div>
        <div *ngIf="pageData.disclaimer" class="disclaimer">
            <span>{{ pageData.disclaimer }}</span>
        </div>
    </div>
    
    <div class="buttons">
        <button class="xm-btn-link-light cancel" (click)="onCancel()">{{ pageData.cancelCta }}</button>
        <button class="xm-btn-primary-light" [disabled]="!isButtonEnabled" [ngClass]="{ 'disabled': !isButtonEnabled }"
            (click)="onSubmit()">{{ primaryCtaText }}</button>
    </div>
</section>
